document.addEventListener('DOMContentLoaded', function() {
  var footerAccordion = document.querySelectorAll(".footer-block__heading");
  footerAccordion.forEach(button => {
    button.addEventListener('click', function() {
      if(this.classList.contains("active")) {
        this.classList.remove("active")
        slideUp(this.nextElementSibling)
      } else {
        let currentActiveButton = document.querySelector(".footer-block__heading.active")
        if(currentActiveButton) {
          currentActiveButton.classList.remove("active")
          slideUp(currentActiveButton.nextElementSibling)
        }

        this.classList.add("active")
        slideDown(this.nextElementSibling)
      }
    })
  })
});

const slideDown = (target, duration = 600, showDisplay = 'flex') => {
target.style.removeProperty('display')
target.style.display = showDisplay
let height = target.offsetHeight;
target.style.overflow = 'hidden';
target.style.height = 0;
target.style.paddingTop = 0;
target.style.paddingBottom = 0;
target.style.marginTop = 0;
target.style.marginBottom = 0;
target.offsetHeight;
target.style.boxSizing = 'border-box';
target.style.transitionProperty = 'height';
target.style.transitionDuration = duration + 'ms';
target.style.height = height + 'px';
window.setTimeout(() => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
}

const slideUp = (target, duration = 500) => {
target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.boxSizing = 'border-box';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(() => {
    target.style.display = 'none';
    target.style.removeProperty('height');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
}